<template>
  <div>
    <transition name="modal-fade">
      <div class="overlay" v-if="show" @click.self="$emit('close')">
        <div class="top-bar">
          <div class="wrap">
            <p class="title">{{ title }}</p>
            <button class="close-btn" @click="$emit('close')">
              <span class="circle">&times;</span>
              <span class="text">Close</span>
            </button>
          </div>
        </div>
        <div class="center">
          <slot/>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name:"Modal",
  props:{
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Introduction: Specific Heat'
    }
  }

}
</script>


<style lang="scss">
  .overlay{
    overflow: auto;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba($darkblue, 0.96);
    backdrop-filter: blur(10px);

    @supports(backdrop-filter: blur(10px)){
      backdrop-filter: blur(10px);
      background: rgba($darkblue, 0.85);
    }

    .top-bar{
      width: 100%;
      height: 4.4rem;
      position: absolute;
      top: 2rem;
      left: 0;
      display: flex;
      justify-content: center;

      .wrap{
        max-width: 80rem;
        width: 95%;
        display: flex;

        .title{
          flex: 1 1 auto;
          text-align: left;
          color: $light;
          text-transform: uppercase;
          font-weight: bold;
          font-size: 1rem;
        }

        .close-btn{
          background: none;
          color: $light;
          border: none;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          span{display: block;}

          .circle{
            font-size: 1.7rem;
            height: 30px;
            width: 30px;
            line-height: 1.5rem;
            border: solid 4px $light;
            border-radius: 100px;
            text-align: center;
            font-weight: bold;
          }

          .text{
            font-size: 1.3rem;
            font-weight: bold;
            text-align: center;
            text-transform: uppercase;
            letter-spacing: 0.18em;
            margin-top: 0.1rem;
          }
        }
      }
    }
  }

  .center{
    max-width: 80rem;
    width: 95%;
    margin: 0 auto;
  }



  .modal-fade-enter-active, .modal-fade-leave-active {
    transition: all 250ms;
  }
  .modal-fade-enter, .modal-fade-leave-to {
    opacity: 0;
    transform: scale(2);
  }
</style>